"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var baseStyles = require("./BasePanel.css");
var ContainerLoader_1 = require("../../atoms/ContainerLoader/ContainerLoader");
var BasePanel = /** @class */ (function (_super) {
    __extends(BasePanel, _super);
    function BasePanel(props) {
        var _this = _super.call(this, props) || this;
        _this.initialize();
        return _this;
    }
    BasePanel.prototype.getBasePanelContent = function () {
        if (this.props.options && this.props.options.isLoading) {
            return (React.createElement(ContainerLoader_1.default, null));
        }
        else {
            return (this.props.children);
        }
    };
    BasePanel.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: baseStyles.panel, style: this.style }, this.getBasePanelContent()));
    };
    BasePanel.prototype.initialize = function () {
        var background = '';
        if (this.props.options) {
            if (typeof this.props.options.backgroundColor !== 'undefined') {
                background = this.props.options.backgroundColor;
            }
            if (typeof this.props.options.backgroundUrl !== 'undefined') {
                background += " url(" + this.props.options.backgroundUrl + ") center center/cover no-repeat";
            }
        }
        this.style = { background: "" + background };
    };
    return BasePanel;
}(React.Component));
exports.default = BasePanel;
//# sourceMappingURL=BasePanel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/BasePanel/BasePanel.js
// module id = 921
// module chunks = 8